enum CargoTaxiContractListingBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export default CargoTaxiContractListingBillingModel;
